import {
  IStorageNodeProviderFind,
  IStorageNodeProviderListItem,
  StorageNodeProviderSortField,
} from "api/entities/storage-node-providers";
import { EntityActions, EntityThunkActions } from "./entity";
import { DialogActions } from "./dialog";
import { IDeleteBlockedConfirmationDataV2 } from "components/shard-clusters/dialogs/delete-blocked-confirmation/delete-blocked-confirmation";
import { IShardRepositoryCredentialsConfirmationData } from "api/entities/shard-repository";
import { storageNodeProviderService } from "api/services/storage-node-providers";
import { commonActions, handleApi } from "./common";

export const STORAGE_PROVIDER_ENTITY_NAME = "storageProvider";
export const DELETE_CONFIRMATION_DIALOG_NAME = "deleteConfirmation";
export const DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME =
  "deleteBlockedConfirmation";
export const CREDENTIALS_INFO = "credentialsConfirmation";

class StorageProviderActions {
  readonly entity;
  readonly deleteConfirmation;
  readonly deleteBlockedConfirmation;
  readonly replaceStorageConfirmation;
  readonly credentialsInfo;

  constructor() {
    let entityName = STORAGE_PROVIDER_ENTITY_NAME;
    this.entity = new EntityActions<
      IStorageNodeProviderListItem,
      IStorageNodeProviderFind
    >(entityName);
    this.deleteConfirmation = new DialogActions<IStorageNodeProviderListItem>(
      entityName,
      DELETE_CONFIRMATION_DIALOG_NAME
    );
    this.deleteBlockedConfirmation =
      new DialogActions<IDeleteBlockedConfirmationDataV2>(
        entityName,
        DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME
      );
    this.credentialsInfo =
      new DialogActions<IShardRepositoryCredentialsConfirmationData>(
        entityName,
        CREDENTIALS_INFO
      );
  }
}

export const storageProviderActions = new StorageProviderActions();

class StorageProviderThunkActions {
  readonly entity;

  constructor() {
    this.entity = new EntityThunkActions<IStorageNodeProviderListItem, StorageNodeProviderSortField, IStorageNodeProviderFind>(
        STORAGE_PROVIDER_ENTITY_NAME,
        storageNodeProviderService
      );
  }

  delete(providerId: string) {
    return (dispatch) => {
      return handleApi(storageNodeProviderService
        .delete(providerId)
        .then(() => {
          dispatch(
            commonActions.showSnackBar(
              true,
              `Storage Node Provider successfully deleted.`
            )
          );
          dispatch(this.entity.fetchPage());
        }), true);
    };
  }
}
export const storageNodeProviderThunkActions = new StorageProviderThunkActions();